<template>
    <div>
        <select-bar
                class="p-p-3 p-d-flex p-jc-between"
                v-on:updateGrade="updateGrade"
                v-on:updatePupil="updatePupil"
                v-on:updateReportName="updateReportName"
                ref="select-bar"/>
        <pupils-list
            class="p-pr-3 p-pl-3 "
            :refreshData="refreshData"
            :selectedGrade="selectedGrade"
            :selectedPupil=" selectedPupil"
            :selectedReportName="selectedReportName"/>

    </div>

</template>

<script>
import SelectBar from '@/views/report/pupilReport/pupilSelectBar.vue'
import PupilsList from '@/views/report/pupilReport/puilList.vue'

export default {
    name: "pupilReport",
    components: {SelectBar, PupilsList},
    props: {
        refreshData: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            selectedGrade: null,
            selectedPupil: null,
            selectedReportName: null,
        }
    },
    methods: {
        updateGrade(grade) {
            this.selectedGrade = grade
        },
        updatePupil(pupil) {
            this.selectedPupil = pupil
        },
        updateReportName(name) {
            this.selectedReportName = name
        },
    },
}
</script>

<style scoped>

</style>